import {Auth} from 'aws-amplify'
import axios from 'axios'

export default {
  mounted() {},
  methods: {
    async getEvents() {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/account/events',
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getMyAccount() {
      try {
        const profile = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/account/myprofile',
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return profile.data
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getAccountById(userId) {
      try {
        const profile = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/account/profiles/' + userId,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return profile.data
      } catch (error) {
        if (error.response && error.response.status === 400) {
          alert('Non existing user!')
        } else {
          alert(this.getCommonErrorMessage(error))
        }
        return false
      }
    },
    async editMyAccount(data) {
      try {
        const attribute = await axios.patch(
          process.env.VUE_APP_API_ENDPOINT + '/account/myprofile',
          data,
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return attribute.data
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async deleteAccount() {
      try {
        const result = await axios.delete(
          process.env.VUE_APP_API_ENDPOINT + '/account',
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
  },
}
